export default "__VITE_PUBLIC_ASSET__c0efd28b__"